import { Card, CardContent } from "@/components/ui/card";
import { FileText, Home, BadgeCheck, AlertTriangle } from "lucide-react";
import { useShelters } from "@/hooks/useShelters";
import { isUrgentNeedsActive } from "@/types/shelter";

interface AdminStatsCardsProps {
  pendingUpdatesCount: number;
}

export const AdminStatsCards = ({ pendingUpdatesCount }: AdminStatsCardsProps) => {
  const { data: shelters } = useShelters();

  const totalShelters = shelters?.length ?? 0;
  const verifiedOrgs = shelters?.filter((s) => s.organization_verified).length ?? 0;
  const urgentShelters = shelters?.filter(isUrgentNeedsActive).length ?? 0;

  const stats = [
    { label: "Oczekujące", value: pendingUpdatesCount, icon: FileText, color: "text-muted-foreground" as const, bg: "bg-muted" as const },
    { label: "Schroniska", value: totalShelters, icon: Home, color: "text-primary" as const, bg: "bg-primary/10" as const },
    { label: "Zweryfikowane", value: verifiedOrgs, icon: BadgeCheck, color: "text-primary" as const, bg: "bg-primary/10" as const },
    { label: "Pilne potrzeby", value: urgentShelters, icon: AlertTriangle, color: "text-destructive" as const, bg: "bg-destructive/10" as const },
  ];

  return (
    <div className="grid grid-cols-4 gap-3">
      {stats.map((stat, i) => (
        <Card
          key={stat.label}
          className="animate-fade-in hover-scale overflow-hidden relative"
          style={{ animationDelay: `${i * 80}ms`, animationFillMode: "both" }}
        >
          <stat.icon className={`absolute -right-1 -bottom-1 w-10 h-10 ${stat.color} opacity-[0.04]`} />
          <CardContent className="p-3 flex items-center gap-2.5 relative">
            <div className={`w-8 h-8 rounded-lg ${stat.bg} flex items-center justify-center shrink-0`}>
              <stat.icon className={`w-4 h-4 ${stat.color}`} />
            </div>
            <div>
              <p className="text-xl font-extrabold text-foreground leading-none tracking-tight">{stat.value}</p>
              <p className="text-[11px] text-muted-foreground mt-0.5 font-medium">{stat.label}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
